import type { TenantFeature } from '../models/tenantFeatures';
import { useAppContext } from '../context/AppContext';

export const useIsTenantFeatureEnabled = (feature: TenantFeature): boolean => {
  const { tenantFeatures } = useAppContext();
  return tenantFeatures[feature];
};
